import { textBlack, primaryColor, webFont, textGrey } from '../../config/theme';

export default {
  cardImgInput: {
    marginLeft: 20,
    minHeight: 20,
    maxHeight: 60,
    minWidth: 61,
    maxWidth: 120
  },
  cuisineButton: {
    height: "40px",
    borderRadius: "20px",
    minWidth:'120px',
    lineHeight: "25px",
    fontFamily: webFont,
    margin: '0 3px 5px',
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 'normal',
  },
  cuisineButtonSelected: {
    height: "40px",
    borderRadius: "20px",
    minWidth:'120px',
    fontSize: "14px",
    lineHeight: "25px",
    fontFamily: webFont,
    margin: '0 3px 5px',
    color: "white",
    textTransform: "none",
    boxShadow: 'none',
    fontWeight: 'normal',
  },
  cuisineButtonContainer: {},
  headerText: {
    fontSize: 32,
    textAlign: "left",
    margin: 0,
    paddingBottom: 15,
    fontFamily: webFont,
    fontWeight: 500,
  },
  subHeaderText: {
    fontSize: 14,
    textAlign: "left",
    margin: '1px 0 32px',
    fontFamily: webFont
  },

  contentContainer: {
    paddingTop: 10
  },
  inputButtonContainer: {
    display: "flex"
  },
  dayButton: {
    width: 36,
    minWidth: 36,
    height: 36,
    borderRadius: 32,
    fontFamily: webFont,
    color: primaryColor,
    fontSize: 16,
    marginLeft: 16,
    lineHeight: "11px"
  },
  dayButtonSelected: {
    width: 36,
    minWidth: 36,
    height: 36,
    borderRadius: 32,
    fontFamily: webFont,
    color: "white",
    fontSize: 16,
    marginLeft: 16,
    lineHeight: "11px",
    boxShadow: 'none',
  },
  labelText: {
    fontSize: 18,
    textAlign: "left",
    margin: '30px 0 27px',
    fontFamily: webFont
  },
  labText: {
    fontSize: 15,
    textAlign: "center",
    margin: 0,
    marginTop: 5,
    fontFamily: webFont,
    textTransform: 'uppercase',
    fontWeight: '500'
  },
  repeats: {
    fontSize: 18,
    textAlign: "left",
    margin: 0,
    marginTop: 5,
    fontFamily: webFont
  },
  fieldContainer: {
    padding: 10
  },
  stepNumber: {
    opacity: 0.12,
    fontSize: 14,
    color: textBlack,
    fontFamily: webFont,
    fontWeight: '500',
    margin: 0,
  },
  stepText: {
    fontSize: 17,
    fontWeight: 500,
    color: '#ff8000',
    fontFamily: webFont,
    margin: '5px 0 16px',
  },
  stepSelected: {
    fontSize: 17,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '5px 0 16px',
  },
  stepNumberUnselected: {
    opacity: 0.3,
    fontSize: 14,
    color: "#000000",
    fontFamily: webFont,
    fontWeight: '500',
    margin: '5px 0 16px',
  },
  stepUnselected: {
    opacity: 0.3,
    fontSize: 17,
    fontWeight: 500,
    color: "#000000",
    fontFamily: webFont,
    margin: '5px 0 16px',
  },

  itemStyle: {
    margin: '0 0 24px',
    padding: 0,
    borderBottom: "1px solid lightgray"
  },

  error: {
    fontSize: 12,
    color: "red",
    fontFamily: webFont
  },
  submitButton: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: "200px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 26px'
  },
  submitButtoniPad: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: "170px",
    color: "white",
    height: 75,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 20px',
    marginRight: 10,
  },
  draftButton: {
    boxShadow: 'none',
    borderRadius: 42,
    borderWidth: 1,
    borderColor: primaryColor,
    color: primaryColor,
    border: "none",
    minWidth: "200px",
    backgroundColor: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 26px',
    marginRight: 10
  },
  purchaseButton: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: "180px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 20px',
    marginLeft: 20,
  },
  subscribeButton: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: "180px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 20px'
  },
  cancelButton: {
    boxShadow: 'none',
    borderRadius: 42,
    color: primaryColor,
    border: "1px solid #ff8000",
    minWidth: "180px",
    backgroundColor: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 20px',
    marginRight: 15,
  },
  subscribeButtonDisabled: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: '#c2c2c2',
    border: "none",
    minWidth: "180px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 20px'
  },
  disabledSubmitButton: {
    boxShadow: 'none',
    borderRadius: 42,
    backgroundColor: textGrey,
    border: "none",
    minWidth: "200px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    fontSize: 18,
    padding: '10px 26px'
  },
  skipButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: "150px",
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "normal",
    marginLeft: 10,
    boxShadow: 'none',
    fontSize: 18,
    padding: '10px 26px'
  },
  createButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "180px",
    color: "white",
    height: 44,
    fontFamily: webFont,
    textTransform: "none",
    boxShadow: 'none',
    fontSize: 15,
    fontWeight: 'normal'
  },
  createButtonDisabled: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "180px",
    color: "white",
    height: 44,
    opacity: 0.5,
    fontFamily: webFont,
    textTransform: "none",
    fontSize: 15,
    boxShadow: 'none',
    fontWeight: 'normal'
  },
  submitButtonDisabled: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "200px",
    color: "white",
    fontWeight: "normal",
    height: 44,
    opacity: 0.5,
    fontFamily: webFont,
    textTransform: "none",
    boxShadow: 'none',
    fontSize: 15,
  },
  submitButtonDisablediPad: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "180px",
    color: "white",
    fontWeight: "normal",
    height: 75,
    opacity: 0.5,
    fontFamily: webFont,
    textTransform: "none",
    boxShadow: 'none',
    fontSize: 15,
    marginRight: 5,
  },
  buttonContainer: {
    textAlign: "left",
    marginTop: 24
  },
  scheduleButton: {
    height: 49,
    borderRadius: 6,
    lineHeight: 0,
    fontFamily: webFont,
    width: "87.5%"
  },
  scheduleCreateButton: {
    height: 49,
    borderRadius: 6,
    lineHeight: 0,
    fontFamily: webFont,
    width: "86%"
  },
  buttonText: {
    fontSize: "16px",
    fontFamily: webFont,
    textTransform: "none"
  },
  textFont: {
    fontFamily: webFont,
    margin: '4px 0 0',
    fontSize: 14,
    fontWeight: '500',
    color: textBlack,
  },
  cardButton: {
    borderRadius: 25,
    backgroundColor: "lightgreen",
    border: "none",
    minWidth: 200,
    color: "white",
    fontWeight: "normal",
    height: 48,
    fontFamily: webFont,
    boxShadow: 'none',
    fontSize: 18,
    textTransform: 'none',
  },
  cuisineText: {
    fontFamily: webFont
  },
  suggestionText: {
    padding: 5,
    fontFamily: webFont
  },
  suggenstionBox: {
    backgroundColor: "white",
    zIndex: 100,
    height: 30,
    borderBottom: "0.5px solid gray",
    cursor: "pointer"
  },
  slotButton: {
    marginTop: 10,
    width: "100%"
  },
  slotButtonText: {
    marginTop: 10,
    marginBottom: 5,
    fontFamily: webFont,
    color: "white",
    fontSize: 15
  },
  selectedSubContainer: {
    //borderBottom: '1px solid #ff8000',
    //borderRight: '1px solid #ff8000'
  },
  subContainer: {
    //borderBottom: '1px solid #ff8000',
    //borderRight: '1px solid #ff8000'
  },
  subPriceContainerSelected: {
    backgroundColor: primaryColor,
    padding: '1px 10px',
    borderBottom: '1px solid #ff8000',
    borderRight: '1px solid #ff8000'
  },
  subPriceContainer: {
    backgroundColor: '#fff',
    padding: '1px 10px',
    borderBottom: '1px solid #ff8000',
    borderRight: '1px solid #ff8000'
  },
  planName: {
    textAlign: 'center',
    fontSize: 24,
    fontWeight: '500',
    color: '#000',
    margin: '25px 0px 30px',
  },
  planPrice: {
    textAlign: 'center',
    fontSize: 20  ,
    fontWeight: '500',
    color: '#000'
  },
  evenRow: {
    backgroundColor: '#fff',
    padding: '7px 10px',
    borderBottom: '1px solid #ff8000',
    borderRight: '1px solid #ff8000'
  },
  evenRowText: {
    color: '#a8a8a8',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
  },
  evenRowTextSelected: {
    color: '#000',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
  },
  oddRow: {
    backgroundColor: '#fff',
    padding: '7px 10px',
    borderBottom: '1px solid #ff8000',
    borderRight: '1px solid #ff8000'
  },
  oddRowTextSelected: {
    color: '#000',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
  },
  oddRowText: {
    color: '#a8a8a8',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
  },
  monthlyText: {
    color: primaryColor,
    fontSize: 20,
    fontWeight: '600',
    marginRight: 0,
    marginTop: 5,
  },
  yearlyText: {
    color: '#000',
    fontSize: 20,
    fontWeight: '600',
    marginRight: 0,
    marginTop: 5,
  },
  planDescHeads: {
    fontSize: 20,
    fontWeight: '500'
  },
  additionalText: {
    fontSize: 12,
    color: '#000',
    textAlign: 'center',
    marginTop: -15,
  },
  inputBox: {
    minWidth: 100,
    maxWidth: 140,
  }
};
